import React from 'react';
import { Card, Row, Col, Button, Typography, Space } from 'antd';
import {
  DollarOutlined,
  TeamOutlined,
  BarChartOutlined,
  EnvironmentOutlined,
  RiseOutlined,
  TrophyOutlined,
} from '@ant-design/icons';

const { Text } = Typography;

/**
 * Quick Actions Component
 * Predefined queries for common analytics requests
 */
const QuickActions = ({ onActionClick }) => {
  const quickActions = [
    {
      category: 'Sales Performance',
      icon: <DollarOutlined />,
      color: '#52c41a',
      actions: [
        { label: 'Sales this month', query: 'What were our sales this month?' },
        { label: 'Sales this quarter', query: 'Show me sales for this quarter' },
        { label: 'Sales this year', query: 'What are our total sales this year?' },
        { label: 'Compare vs last month', query: 'Compare this month sales vs last month' },
      ],
    },
    {
      category: 'Product Mix',
      icon: <BarChartOutlined />,
      color: '#1890ff',
      actions: [
        { label: 'Top selling mixes', query: 'Which concrete mixes are selling best this month?' },
        { label: 'Mix performance', query: 'Show me sales by PSI for this quarter' },
        { label: 'Mix trends', query: 'What are the sales trends by mix this year?' },
      ],
    },
    {
      category: 'Customers',
      icon: <TeamOutlined />,
      color: '#722ed1',
      actions: [
        { label: 'Top customers', query: 'Who are our top 10 customers by revenue this month?' },
        { label: 'Top by yards', query: 'Show me top customers by cubic yards this quarter' },
        { label: 'Customer distribution', query: 'Which cities have the most customers?' },
      ],
    },
    {
      category: 'Geographic',
      icon: <EnvironmentOutlined />,
      color: '#fa8c16',
      actions: [
        { label: 'Sales by city', query: 'What cities are buying the most concrete?' },
        { label: 'Top cities', query: 'Show me top 5 cities by revenue this month' },
      ],
    },
    {
      category: 'Plant Performance',
      icon: <RiseOutlined />,
      color: '#13c2c2',
      actions: [
        { label: 'Sales by plant', query: 'Show me sales by plant for this month' },
        { label: 'Plant comparison', query: 'Compare plant performance this quarter' },
      ],
    },
  ];

  return (
    <div style={{ marginBottom: '16px' }}>
      <Text type="secondary" style={{ display: 'block', marginBottom: '12px' }}>
        💡 Quick Actions - Click to ask common questions:
      </Text>
      <Row gutter={[12, 12]}>
        {quickActions.map((category, catIndex) => (
          <Col xs={24} sm={12} lg={8} key={catIndex}>
            <Card
              size="small"
              title={
                <Space>
                  <span style={{ color: category.color }}>{category.icon}</span>
                  <Text strong style={{ fontSize: '13px' }}>
                    {category.category}
                  </Text>
                </Space>
              }
              bodyStyle={{ padding: '8px' }}
            >
              <Space direction="vertical" size="small" style={{ width: '100%' }}>
                {category.actions.map((action, actionIndex) => (
                  <Button
                    key={actionIndex}
                    type="text"
                    size="small"
                    onClick={() => onActionClick(action.query)}
                    style={{
                      width: '100%',
                      textAlign: 'left',
                      height: 'auto',
                      whiteSpace: 'normal',
                      padding: '4px 8px',
                    }}
                  >
                    {action.label}
                  </Button>
                ))}
              </Space>
            </Card>
          </Col>
        ))}
      </Row>
    </div>
  );
};

export default QuickActions;
